import * as types from '../constants/actionTypes';
import { prepareOccupations } from '../utils/occupation-utils';

const initialState = {
    error: null,
    loading: false,
    occupations: [],
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case types.FETCH_OCCUPATIONS:
            return {
                ...state,
                loading: true,
            };
        case types.FETCH_OCCUPATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                occupations: prepareOccupations(action.result),
            };
        case types.FETCH_OCCUPATIONS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.result,
            };
        default:
            return state;
    }
}
